import React from 'react'
import { useState,useEffect } from 'react'
import NavBar from './NavBar'
import "./postview.css"
import Card from './Card'
import Api from '../../Api'

function Postview() {
  return (
    <>
    <Api/>
    </>
    
  )
}

export default Postview